import React, { Suspense, useEffect } from "react";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ToTop from "./components/ToTop";
import { ContactModalProvider } from "./context/ContactModalContext";
import "./assets/styles/main.scss";
import "./App.css";
import { Outlet, useLocation } from "react-router-dom";

function App() {
  const location = useLocation();
  const isAuthPage =
    location.pathname === "/login" || location.pathname === "/register";

  // 路由切换时滚动到页面顶部
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location.pathname]);

  return (
    <ContactModalProvider>
      <div className="app-container">
        {!isAuthPage && <Header />}
        <Outlet />
        {!isAuthPage && <ToTop />}
      </div>
    </ContactModalProvider>
  );
}

export default App;
